import { name } from 'file-loader'
import App from '../App'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default [
	{
		path: '/',
		component: App,
		children: [
			{
				path: '',
				redirect: '/home'
			},
			{
				name: 'home',
				path: '/home',
				component: () => import('@/page/home/home'),
				meta: {
					isshowtabbar: true
				}
			},
			{//活动分类
				name: 'activityCategory',
				path: '/activityCategory',
				component: () => import('@/page/productEvent/ActivityCategory'),
				meta: {
					title: '活动分类'
				}
			},
			{//徽章墙
				name: 'badgeWall',
				path: '/badge-wall',
				component: () => import('@/page/badge-wall/BadgeWall'),
				meta: {
					title: '徽章墙'
				}
			},
			{//市场展会活动
				name: 'exhibition',
				path: '/exhibition',
				component: () => import('@/page/resint/exhibition/Exhibition')
			},
			// {
			// 	name: 'SigninCs',
			// 	path: '/SigninCs',
			// 	component: SigninCs,
			// },
			{//校园行活动
				name: 'campusTour',
				path: '/campusTour',
				component: () => import('@/page/resint/campusTour/CampusTour'),
			},
			{//联系我们
				name: 'contactUs',
				path: '/contactUs',
				component: () => import('@/page/resint/contactUs/ContactUs'),
			},
			{//技术服务
				name: 'technicalServices',
				path: '/technicalServices',
				component: () => import('@/page/resint/technicalServices/TechnicalServices'),
			},
			{//技术服务详情
				name: 'technicalServicesInfo',
				path: '/technicalServicesInfo',
				component: () => import('@/page/resint/technicalServices/child/TechnicalServicesInfo'),
				meta: {
					hideFloatingService: true
				}
			},
			{//试用装
				name: 'sampleSack',
				path: '/sampleSack',
				component: () => import('@/page/resint/sampleSack/SampleSack'),
			},
			{//试用装列表
				name: 'sampleList',
				path: '/sampleList',
				component: () => import('@/page/resint/sampleSack/child/SampleList'),
			},
			{//试用装反馈
				name: 'sampleFeedback',
				path: '/sampleFeedback',
				component: () => import('@/page/resint/sampleSack/child/SampleFeedback'),
			},
			{//无限制反馈
				name: 'noLimitFeedback',
				path: '/noLimitFeedback',
				component: () => import('@/page/resint/sampleSack/child/NoLimitFeedback'),
			},
			{//积分商城
				name: 'pointsMall',
				path: '/pointsMall',
				component: () => import('@/page/points-mall/PointsMall'),
				meta: { hideFloatingService: true }
			},
			{//积分记录列表
				name: 'pointsRecordList',
				path: '/pointsRecordList',
				component: () => import('@/page/points-mall/child/RecordList'),
			},
			{
				name: 'tradeShow',
				path: '/tradeShow',
				component: () => import('@/page/resint/exhibition/child/TradeShow')
			},
			{//产品分类
				name: 'category',
				path: '/category',
				component: () => import('@/page/category/category'),
				meta: {
					isshowtabbar: true
				}
			},
			{//产品列表
				name: 'products',
				path: '/products',
				component: () => import('@/page/product-list/ProductList'),
				meta: {
					keepAlive: true
				}
			},
			{//产品活动页
				name: 'activities',
				path: '/activities',
				component: () => import('@/page/productEvent/index'),
				meta: { keepAlive: true }
			},
			{//每日特价、限时特惠
				name: 'special',
				path: '/special',
				component: () => import('@/page/product-list/child/child/SpecialOffer')
			},
			{
				name: 'search',
				path: '/search',
				component: () => import('@/page/search/Search')
			},
			{
				name: 'signin',
				path: '/signin',
				component: () => import('@/page/auth/Signin')
			},
			{
				name: 'signup',
				path: '/signup',
				component: () => import('@/page/auth/Signup')
			},
			{
				name: 'retrieve',
				path: '/retrieve',
				component: () => import('@/page/auth/Retrieve')
			},
			{
				name: 'mobileConfirm',
				path: '/mobileConfirm',
				component: () => import('@/page/auth/mobile/MobileConfirm')
			},
			{
				name: 'emailConfirm',
				path: '/emailConfirm',
				component: () => import('@/page/auth/email/EmailConfirm')
			},
			{
				name: 'resetPassword',
				path: '/resetPassword',
				component: () => import('@/page/auth/email/EmailResetPassword')
			},
			{
				name: 'bind',
				path: '/bind',
				component: () => import('@/page/auth/Bind')
			},
			{
				name: 'bindPhone',
				path: '/bindPhone',
				component: () => import('@/page/auth/BindPhone')
			},
			{//我的
				name: 'profile',
				path: '/profile',
				component: () => import('@/page/profile/Profile'),
				meta: { isshowtabbar: true }
			},
			{//设置
				name: 'setting',
				path: '/setting',
				component: () => import('@/page/profile/Setting')
			},
			{//个人信息
				name: 'profileInfo',
				path: '/profileInfo',
				component: () => import('@/page/profile/ProfileInfo')
			},
			{//收藏
				name: 'Collection',
				path: '/collection',
				component: () => import('@/page/profile/Collection')
			},
			{//浏览历史
				name: 'BrowsingHistory',
				path: '/browsingHistory',
				component: () => import('@/page/profile/BrowsingHistory')
			},
			{//地址列表
				name: 'addressList',
				path: '/addressList',
				component: () => import('@/page/address/AddressList')
			},
			{//地址编辑
				name: 'addressEdit',
				path: '/addressManage/addressEdit',
				component: () => import('@/page/address/AddressEdit'),
				meta: { keepAlive: false }
			},
			{//红包
				name: 'cashgiftList',
				path: '/cashgiftList',
				component: () => import('@/page/cashgift/CashgiftList')
			},
			{//订单
				name: 'order',
				path: '/order/:order?',
				component: () => import('@/page/order/Order')
			},
			{//订单详情
				name: 'orderDetail',
				path: '/orderDetail/:orderDetail?',
				component: () => import('@/page/order/OrderDetail')
			},
			{//订单跟踪
				name: 'orderTrack',
				path: '/orderTrack/:orderTrack?',
				component: () => import('@/page/order/child/OrderTrack')
			},
			{//订单交易
				name: 'orderTrade',
				path: '/orderTrade',
				component: () => import('@/page/order/child/OrderTrade')
			},
			{//订单评价
				name: 'orderComment',
				path: '/orderComment',
				component: () => import('@/page/order/child/OrderComment')
			},
			{//订单提交
				name: 'orderSubmit',
				path: '/orderSubmit',
				component: () => import('@/page/order/child/OrderSubmit')
			},
			{//产品详情
				name: 'product',
				path: '/product/:id?/:productId?',
				component: () => import('@/page/product-detail/ProductDetail'),
			},
			{//购物车
				name: 'cart',
				path: '/cart',
				component: () => import('@/page/cart/index'),
				meta: {
					isshowtabbar: true,
					hideFloatingService: true
				}
			},
			{//购物车结算页
				name: 'checkout',
				path: '/checkout',
				component: () => import('@/page/checkout/index.vue'),
				meta: {
					hideFloatingService: true
				}
			},
			{//银行转账 / 对公支付详情
				name: 'payInfo',
				path: '/payInfo',
				component: () => import('@/page/checkout/child/payInfo.vue'),
				meta: {
					hideFloatingService: true
				}
			},
			{//红包
				name: 'bonus',
				path: '/bonus',
				component: () => import('@/page/checkout/child/bonus.vue'),
				meta: {
					// keepAlive: true,
					hideFloatingService: true
				}
			},
			{//个人信息编辑
				name: 'profileEdit',
				path: '/profileEdit/:type',
				component: () => import('@/page/profile/ProfileEdit')
			},
			{//积分记录列表
				name: 'score',
				path: '/score',
				component: () => import('@/page/profile/child/score')
			},
			{//展会抽奖活动信息征集
				name: 'lotteryContest',
				path: '/lotteryContest',
				component: () => import('@/page/resint/information/lotteryContest.vue'),
				meta: { hideFloatingService: true }
			},
			{//电影票申请
				name: 'newYearHelp',
				path: '/newYearHelp',
				component: () => import('@/page/resint/newYearHelp/index')
			},
			{//电影票申请列表
				name: 'newYearList',
				path: '/newYearList',
				component: () => import('@/page/resint/newYearHelp/child/NewYearList')
			},
			{
				name: 'premium_courses',
				path: '/premium_courses',
				component: () => import('@/page/resint/premiumCourses/index')
			},
			{//抗体申请
				name: 'ktApply',
				path: '/ktApply',
				component: () => import('@/page/resint/ktApply/KtApply')
			},
			{
				name: 'QrCodecs',
				path: '/QrCodecs',
				component: () => import('@/page/resint/QrCodeCs/QrCode')
			},
			{
				name: 'QrDetailscs',
				path: '/QrDetailscs',
				component: () => import('@/page/resint/QrCodeCs/QrDetails')
			},
			{//扫码查看产品数据
				name: 'QrCode',
				path: '/QrCode',
				component: () => import('@/page/resint/QrCode/QrCode')
			},
			{//扫码查看产品数据详情
				name: 'QrDetails',
				path: '/QrDetails',
				component: () => import('@/page/resint/QrCode/QrDetails'),
				meta: { hideFloatingService: true }
			},
			{//扫码领积分
				name: 'scanCode',
				path: '/scanCode',
				component: () => import('@/page/resint/ScanCode/ScanCodePoints'),
				meta: { hideFloatingService: true }
			},
			{//病理杯
				name: 'pathologicalCup',
				path: '/pathologicalCup',
				component: () => import('@/page/resint/CathologicalCup/index'),
				meta: { hideFloatingService: true }
			},
			{//病理杯投票
				name: 'pathologicalCupVote',
				path: '/pathologicalCupVote',
				component: () => import('@/page/resint/information/cultureContest/formula'),
				meta: { hideFloatingService: true }
			},
			{//病理杯详情
				name: 'particulars',
				path: '/particulars',
				component: () => import('@/page/resint/information/cultureContest/particulars'),
				meta: { hideFloatingService: true }
			},
			{//奖学金
				name: 'activityJxj',
				path: '/activityJxj',
				component: () => import('@/page/home/child/child/activityJxj')
			},
			{//新闻
				name: 'newMore',
				path: '/newMore',
				component: () => import('@/page/home/child/child/newMore')
			},
			{
				name: 'newsDetail',
				path: '/newsDetail',
				component: () => import('@/page/resint/precinct/info')
			},
			{//通路图
				name: 'xhtlMore',
				path: '/xhtlMore',
				component: () => import('@/page/home/child/child/xhtlMore')
			},
			{
				name: 'xhtlDeta',
				path: '/xhtlDeta',
				component: () => import('@/page/home/child/child/xhtlDeta')
			},
			{//三月活动
				name: 'marchActivities',
				path: '/marchActivities',
				component: () => import('@/page/resint/Activities/MarchActivities/index')
			},
			{//试用装回购（抗体/蛋白/多肽 type=1，ELISA type=2，共用同一组件）
				name: 'recorder',
				path: '/recorder',
				component: () => import('@/page/resint/sampleRepurchase/recorder'),
				meta: { hideFloatingService: true }
			},
			{
				name: 'sources',
				path: '/sources',
				component: () => import('@/page/resint/sampleRepurchase/recorder'),
				meta: { hideFloatingService: true }
			},
			{//售后服务
				name: 'afterService',
				path: '/afterService',
				component: () => import('@/page/afterService/index')
			},
			{//售后服务表单
				name: 'afterServiceForm',
				path: '/afterServiceForm',
				component: () => import('@/page/afterService/afterServiceFrom')
			},
			{//售后服务列表
				name: 'afterServiceList',
				path: '/afterServiceList',
				component: () => import('@/page/afterService/list'),
				meta: { keepAlive: true }
			},
			{//售后服务详情
				name: 'afterServiceInfo',
				path: '/afterServiceInfo',
				component: () => import('@/page/afterService/info')
			},
			{//售后服务补充
				name: 'afterServiceSupplement',
				path: '/afterServiceSupplement',
				component: () => import('@/page/afterService/supplement')
			},
			{//售后服务申请成功
				name: 'applySuccess',
				path: '/applySuccess',
				component: () => import('@/page/afterService/applySuccess')
			},
			{//资讯中心
				name: 'informationCenter',
				path: '/informationCenter',
				component: () => import('@/page/resint/precinct/informationCenter.vue'),
				meta: { keepAlive: true }
			},
			{//实验视频
				name: 'labVid',
				path: '/labVid',
				component: () => import('@/page/resint/labVid/index.vue'),
				meta: { keepAlive: true }
			},
			{//实验视频详情
				name: 'labVidInfo',
				path: '/labVidInfo',
				component: () => import('@/page/resint/labVid/Info.vue')
			},
			{//产品图库
				name: 'productGallery',
				path: '/productGallery',
				component: () => import('@/page/resint/precinct/productGallery.vue'),
				meta: { keepAlive: true }
			},
			{//技术文章
				name: 'technicalArticle',
				path: '/technicalArticle',
				component: () => import('@/page/resint/precinct/technicalArticle.vue'),
				meta: { keepAlive: true }
			},
			{//定制服务
				name: 'customService',
				path: '/customService',
				component: () => import('@/page/resint/customService/index'),
				// meta: { keepAlive: true }
			},
			{//定制服务表单
				name: 'customServiceForm',
				path: '/customServiceForm',
				component: () => import('@/page/resint/customService/form')
			},
			{//定制服务列表
				name: 'customServiceList',
				path: '/customServiceList',
				component: () => import('@/page/resint/customService/list'),
				meta: { keepAlive: true }
			},
			{//定制服务详情
				name: 'customServiceInfo',
				path: '/customServiceInfo',
				component: () => import('@/page/resint/customService/info'),
				meta: { hideFloatingService: true }
			},
			{//产品资料
				name: 'productsBookList',
				path: '/productsBookList',
				component: () => import('@/page/resint/precinct/productsBookList.vue')
			},
			{//百万教育金
				name: 'millionFund',
				path: '/millionFund',
				component: () => import('@/page/resint/millionFund/millionFund.vue')
			},
			{//百万教育金列表
				name: 'millionFundList',
				path: '/millionFundList',
				component: () => import('@/page/resint/millionFund/list.vue'),
				meta: { keepAlive: true }
			},
			{//百万教育金详情
				name: 'millionFundInfo',
				path: '/millionFundInfo',
				component: () => import('@/page/resint/millionFund/info.vue')
			},
			{//线上讲座
				name: 'onlineLecture',
				path: '/onlineLecture',
				component: () => import('@/page/resint/onlineLecture/index.vue')
			},
			{//线上讲座列表
				name: 'onlineLectureList',
				path: '/onlineLectureList',
				component: () => import('@/page/resint/onlineLecture/list.vue')
			},
			{//线上讲座详情
				name: 'onlineLectureInfo',
				path: '/onlineLectureInfo',
				component: () => import('@/page/resint/onlineLecture/info.vue')
			},
			{//线上讲座征集表
				name: 'onlineLectureForm',
				path: '/onlineLectureForm',
				component: () => import('@/page/resint/onlineLecture/form.vue')
			},
			// {//遇见良缘·专属心动
			// 	name: 'matchmakingEvent',
			// 	path: '/matchmakingEvent',
			// 	component: () => import('@/page/resint/information/matchmakingEvent.vue'),
			// 	meta: { hideFloatingService: true }
			// },
			// {//遇见良缘·专属心动 后台管理系统
			// 	path: '/admin/ylxd',
			// 	name: 'ylxdAdminWap',
			// 	component: { template: '<router-view />' },
			// 	redirect: '/admin/ylxd/login',
			// 	meta: { hideFloatingService: true },
			// 	children: [
			// 		{//遇见良缘·专属心动 后台登录
			// 			path: 'login',
			// 			name: 'ylxdLogin',
			// 			component: () => import('@/page/admin/matchmakingEvent/login.vue'),
			// 			meta: { hideFloatingService: true }
			// 		},
			// 		{//遇见良缘·专属心动 后台列表
			// 			path: 'list',
			// 			name: 'ylxdList',
			// 			component: () => import('@/page/admin/matchmakingEvent/list.vue'),
			// 			meta: { hideFloatingService: true, keepAlive: true }
			// 		},
			// 		{//遇见良缘·专属心动 后台详情
			// 			path: 'detail',
			// 			name: 'ylxdDetail',
			// 			component: () => import('@/page/admin/matchmakingEvent/detail.vue'),
			// 			meta: { hideFloatingService: true }
			// 		},
			// 	]
			// },
			// {//遇见良缘·专属心动 前台wap页面
			// 	path: '/wap/ylxd',
			// 	name: 'ylxdWap',
			// 	component: { template: '<router-view />' },
			// 	redirect: '/wap/ylxd/login',
			// 	meta: { hideFloatingService: true },
			// 	children: [
			// 		{
			// 			path: 'login',
			// 			name: 'ylxdLoginWap',
			// 			component: () => import('@/page/wap/matchmakingEvent/login.vue'),
			// 			meta: { hideFloatingService: true }
			// 		},
			// 		{
			// 			path: 'list',
			// 			name: 'ylxdListWap',
			// 			component: () => import('@/page/wap/matchmakingEvent/list.vue'),
			// 			meta: { hideFloatingService: true }
			// 		},
			// 		{
			// 			path: 'mine',
			// 			name: 'ylxdMineWap',
			// 			component: () => import('@/page/wap/matchmakingEvent/mine.vue'),
			// 			meta: { hideFloatingService: true }
			// 		},
			// 		{
			// 			path: 'info',
			// 			name: 'ylxdInfoWap',
			// 			component: () => import('@/page/wap/matchmakingEvent/info.vue'),
			// 			meta: { hideFloatingService: true }
			// 		}
			// 	]
			// },
			{//文创竞赛
				name: 'cultureContest',
				path: '/cultureContest',
				component: () => import('@/page/resint/information/cultureContest.vue'),
				meta: { hideFloatingService: true }
			},
			{//套餐列表页
				name: 'package',
				path: '/package',
				component: () => import('@/page/package/list.vue')
			},
			{//套餐详情页
				name: 'packageInfo',
				path: '/package/info',
				component: () => import('@/page/package/info.vue'),
				meta: { hideFloatingService: true }
			},{
				name:'scholarship',
				path: '/scholarship',
				component: () => import('@/page/resint/information/scholarship.vue')
			},
			{
				path: '*',
				redirect: '/'
			},
		]
	}
]

// const router = new VueRouter({
//   mode: 'history', //路由模式(默认为hash模式)
// 	debug: true
// })


// WEBPACK FOOTER //
// ./src/router/router.js